import { Theme } from '.'
import colors from '../global/color'
import BaseTheme from './BaseTheme'

const FlyinTheme: Theme = {
    ...BaseTheme,
    color: {
        ...BaseTheme.color,
        text: {
            ...BaseTheme.color.text,
            primary: colors.flyinPrimaryText,
            subHeading: colors.flyinSecondaryText
        },
        button: {
            ...BaseTheme.color.button,
            containedSecondaryBg: colors.flyinSecondary,
            containedPrimaryBg: colors.flyinPrimary,
            containedPrimaryLabel: colors.flyinPrimaryText
        },
        dropdown: {
            ...BaseTheme.color.dropdown,
            hoverBg: colors.flyinSecondary,
            hoverText: colors.neutral100,
            selectedBg: colors.flyinSecondary,
            selectedText: colors.neutral100,
            itemColor: colors.flyinPrimaryText,
            itemBg: colors.neutral100
        },
        stepper: {
            ...BaseTheme.color.stepper,
            border: {
                ...BaseTheme.color.stepper.border,
                currentBorder: colors.flyinPrimaryText,
                upcomingBorder: colors.flyinSecondaryText
            },
            divider: {
                ...BaseTheme.color.stepper.divider,
                completedBg: colors.flyinChipBg,
                currentBg: colors.flyinSecondaryText,
                upcomingBg: colors.flyinSecondaryText
            },
            bg: {
                ...BaseTheme.color.stepper.bg,
                completedBg: colors.flyinChipBg
            }
        },
        chip: {
            ...BaseTheme.color.chip,
            nonSelectedPrimaryLabel: colors.flyinChipText,
            nonSelectedPrimaryBorder: colors.flyinChipBorder,
            selectedPrimaryLabel: colors.neutral100,
            selectedPrimaryBorder: colors.flyinChipBg,
            selectedPrimaryBg: colors.flyinChipBg,
            disabledPrimaryLabel: colors.disabledText
        },
        background: {
            ...BaseTheme.color.background,
            brand: colors.flyinSecondary,
            brandLightBg: colors.flyinChipBorder
        },
        border: {
            ...BaseTheme.color.border,
            secondary: colors.flyinPrimary
        }
    }
}

export default FlyinTheme
